<template>
  <div
    @click="tab"
    class="tab"
    :class="[isSelected ? 'selected' : '', hover ? 'hover' : '']"
    @mouseover="mouseover"
    @mouseout="mouseout"
  >
    <img v-svg-inline class="icon default" :src="src" :alt="tabType" />
    <img v-svg-inline class="icon selected" :src="selectedsrc" :alt="tabType" />
    <p v-html="$t(description)" />
  </div>
</template>

<script>
export default {
  props: {
    tabType: {
      type: String,
      default: "",
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hover: false,
    };
  },
  methods: {
    tab() {
      if (this.isSelected == false) {
        this.$emit("tab");
      }
    },
    mouseover() {
      if (this.isSelected == true) {
        return;
      }
      this.hover = true;
    },
    mouseout() {
      if (this.isSelected == true) {
        return;
      }
      this.hover = false;
    },
  },
  computed: {
    src() {
      return require("../assets/imgs/icon_" + this.tabType + ".svg");
    },
    selectedsrc() {
      return require("../assets/imgs/icon_" + this.tabType + "_selected.svg");
    },
    description() {
      return "authorizationType.type." + this.tabType;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.tab
  width: 50%
  height: 40px
  cursor: pointer
  background-color: $gs1
  position: relative
  transition: 0.5s
  +flex(center, center, row)
  &:before
    +size (100%, 3px)
    +abpos(initial, 0, initial, 0)
    content: ""
    background-color: $gs1
  .icon
    &.selected
      +size(0px)
    &.default
      +size(24px)
  p
    +ffw()
    +fs(m)
    height: 40px
    line-height: 40px
    opacity: 1
    color: $gs2
    text-align: center
    margin-left: 4px
  &.hover
    p
      +ffw(bold)
      color: $color1
    .icon
      &.selected
        +size(24px)
      &.default
        +size(0px)
  &.selected
    &:before
      background-color: $color1
    p
      +ffw(bold)
      color: $color1
    .icon
      &.selected
        +size(24px)
      &.default
        +size(0px)
</style>
